export class NETWORK_CONNECTIVITY {
  static readonly pingTimeoutMs = 5000;
  static readonly reconnectionPollingIntervalMs = 30000;
}
